import { PartnerRef } from '@components/referrals/ReferrerDaoForm'
import { TOKEN_PROGRAM_ID } from '@solana/spl-token'
import { Commitment, PublicKey } from '@solana/web3.js'
import { localStorageKey } from 'hooks/useLocalStorageState' // export const LAST_ACCOUNT_KEY = 'mangoAccount-0.4'
import { TokenMetadataItem } from 'types/token'
import { VaultConfig } from 'types/vault'

// export const LAST_ACCOUNT_KEY = 'mangoAccount-0.4'

export const DISCORD_LINK = 'https://discord.gg/MY22UE7Vdm'
export const TWITTER_LINK = 'https://x.com/CabanaExchange'
export const TELEGRAM_LINK = 'https://t.me/Cabana_Exchange'

export const CLIENT_TX_TIMEOUT = 120000

export const SOLANA_TOKEN_DETAILS: TokenMetadataItem = {
  image_url: '/icons/sol.svg',
  mint: 'So11111111111111111111111111111111111111112',
  name: 'Solana',
  symbol: 'SOL',
  latest_price_usd: 0,
  volume_24h_usd: 0,
  amount_24h: 0,
  trades_count_24h: 0,
  decimals: 9,
  description: '',
  twitter: '',
  telegram: '',
  coingecko_id: 'wrapped-solana',
  website: '',
  token_program: TOKEN_PROGRAM_ID.toBase58(),
}

export const USDC_TOKEN_DETAILS: TokenMetadataItem = {
  image_url: '/icons/usdc.svg',
  mint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  name: 'USDC',
  symbol: 'USDC',
  latest_price_usd: 1,
  volume_24h_usd: 0,
  amount_24h: 0,
  trades_count_24h: 0,
  decimals: 6,
  description: '',
  twitter: '',
  telegram: '',
  coingecko_id: 'usd-coin',
  website: 'https://www.usdc.com',
  token_program: TOKEN_PROGRAM_ID.toBase58(),
}

export const STATIC_QUOTE_TOKENS = {
  SOL: SOLANA_TOKEN_DETAILS,
  USDC: USDC_TOKEN_DETAILS,
} as Readonly<{
  [mint in 'SOL' | 'USDC']: Readonly<TokenMetadataItem>
}>
export const STATIC_QUOTE_TOKENS_LIST = Object.values(STATIC_QUOTE_TOKENS)
export const STATIC_QUOTE_TOKEN_MINTS = STATIC_QUOTE_TOKENS_LIST.map(
  ({ mint }) => mint,
)
export const USDC_MINT = STATIC_QUOTE_TOKENS.USDC.mint
export const SOL_MINT = STATIC_QUOTE_TOKENS.SOL.mint
export const USDG_MINT = '2u1tszSeqZ3qBWF3uNGPFc8TzMk2tdiwknnRMWGWjGWH'
export const USDT_MINT = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'

// Destiny Vaults
export const UPCASH_MINT = 'upCASH4EueUGr6QpzmfZcec9DE76SiUipfj97HYMUrS' // upCASH LP token
export const UPCASH_TOKEN_DETAILS: TokenMetadataItem = {
  image_url: 'https://manifest.trade/cash.png',
  mint: UPCASH_MINT,
  name: 'upCASH',
  symbol: 'upCASH',
  latest_price_usd: 1,
  volume_24h_usd: 0,
  amount_24h: 0,
  trades_count_24h: 0,
  decimals: 6,
  description: 'Destiny Vault LP Token for CASH/USDC',
  twitter: '',
  telegram: '',
  coingecko_id: '',
  website: '',
  token_program: TOKEN_PROGRAM_ID.toBase58(),
}

export const PYUSD_MINT = '2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo' // PYUSD base token
export const UPPYUSD_MINT = 'upPyusDv3nEtrUE6ESsX2j6BiZhwBjzogoirFenYg6m' // upPYUSD LP token
export const UPPYUSD_TOKEN_DETAILS: TokenMetadataItem = {
  image_url: '/icons/pyusd.webp',
  mint: UPPYUSD_MINT,
  name: 'upPYUSD',
  symbol: 'upPYUSD',
  latest_price_usd: 1,
  volume_24h_usd: 0,
  amount_24h: 0,
  trades_count_24h: 0,
  decimals: 6,
  description: 'Destiny Vault LP Token for PYUSD/USDC',
  twitter: '',
  telegram: '',
  coingecko_id: '',
  website: '',
  token_program: TOKEN_PROGRAM_ID.toBase58(),
}

export const USDS_MINT = 'USDSwr9ApdHk5bvJKMjzff41FfuX8bSxdKcR81vTwcA' // USDS base token
export const UPUSDS_MINT = 'upUSDSL8V1nhX9B7N51XtHQZ9RAS1v7RKURXrFDdamp' // upUSDS LP token
export const UPUSDS_TOKEN_DETAILS: TokenMetadataItem = {
  image_url: 'https://manifest.trade/_next/image?url=%2FUSDS.png&w=128&q=75',
  mint: UPUSDS_MINT,
  name: 'upUSDS',
  symbol: 'upUSDS',
  latest_price_usd: 1,
  volume_24h_usd: 0,
  amount_24h: 0,
  trades_count_24h: 0,
  decimals: 6,
  description: 'Destiny Vault LP Token for USDS/USDC',
  twitter: '',
  telegram: '',
  coingecko_id: '',
  website: '',
  token_program: TOKEN_PROGRAM_ID.toBase58(),
}

export const VAULT_RISK_ACCEPTED_KEY = localStorageKey(
  'vaultRiskAccepted-0.1',
  false,
)

// Vault Configurations
export const VAULTS_CONFIG: VaultConfig[] = [
  {
    id: 'cash-vault',
    name: 'CASH Vault',
    description: 'Automated market making on CASH/USDC',
    lpToken: 'upCASH',
    lpMint: UPCASH_MINT,
    lpTokenIcon: 'https://manifest.trade/cash.png',
    baseToken: 'CASH',
    quoteToken: 'USDC',
    quoteMint: USDC_MINT,
    destinyVault: '9f1Yp7xprnQE1F2QDfo6dsVh9WAU5UnUNwxM6dtB748V',
    isActive: true,
    isAudited: false,
    apiEndpoint: 'https://destiny-api.fly.dev/upcash',
  },
  {
    id: 'pyusd-vault',
    name: 'PYUSD Vault',
    description: 'Automated market making on PYUSD/USDC',
    lpToken: 'upPYUSD',
    lpMint: UPPYUSD_MINT,
    lpTokenIcon: '/icons/pyusd.webp',
    baseToken: 'PYUSD',
    quoteToken: 'USDC',
    quoteMint: USDC_MINT,
    destinyVault: 'E134fMVzW5za94ivtVJuwKEYm7pMcUgWLVP8YZecCZPR',
    isActive: true,
    isAudited: false,
    apiEndpoint: 'https://destiny-api.fly.dev/uppyusd',
  },
  {
    id: 'usds-vault',
    name: 'USDS Vault',
    description: 'Automated market making on USDS/USDC',
    lpToken: 'upUSDS',
    lpMint: UPUSDS_MINT,
    lpTokenIcon: 'https://manifest.trade/_next/image?url=%2FUSDS.png&w=128&q=75',
    baseToken: 'USDS',
    quoteToken: 'USDC',
    quoteMint: USDC_MINT,
    destinyVault: 'GEP5gQa9wMdADesuyShw2rmFxGAsyGTv2nMj44iKPjH4',
    isActive: true,
    isAudited: false,
    apiEndpoint: 'https://destiny-api.fly.dev/upusds',
  },
]

export const MIN_SOL_BALANCE = 0.003

// export const JUPITER_V4_PROGRAM_ID =
//   'JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB'

// Local storage keys for settings

// export const IS_ONBOARDED_KEY = 'isOnboarded-0.1'

// export const SHOW_ZERO_BALANCES_KEY = 'show-zero-balances-0.2'

// export const SIDEBAR_COLLAPSE_KEY = 'sidebar-0.1'

// export const ONBOARDING_TOUR_KEY = 'showOnboardingTour-0.1'

// export const SOUND_SETTINGS_KEY = 'soundSettings-0.1'

// export const SIZE_INPUT_UI_KEY = 'tradeFormUi-0.2'

// export const TRADE_CHECKBOXES_KEY = 'tradeCheckboxes-0.1'

// export const GRID_LAYOUT_KEY = 'savedLayouts-0.2'

// export const TRADE_CHART_UI_KEY = 'tradeChart-0.3'

// export const FAVORITE_MARKETS_KEY = 'favoriteMarkets-0.2'

// export const THEME_KEY = 'theme-0.1'

export const CONNECTION_COMMITMENT: Commitment = 'confirmed'

export const TRITON_URL = process.env.NEXT_PUBLIC_TRITON_URL
  ? process.env.NEXT_PUBLIC_TRITON_URL
  : 'https://realms.rpcpool.com'

//mainly used for getTokenAccountsByOwner to split traffic between dedicated and shared nodes
export const TRITON_URL_BACKUP = process.env.NEXT_PUBLIC_BACKUP_RPC_URL
  ? process.env.NEXT_PUBLIC_BACKUP_RPC_URL
  : 'https://realms.rpcpool.com'

export const ADDITIONAL_RPC_ENDPOINT = process.env.NEXT_PUBLIC_RPC_ENDPOINT
  ? ({
      label: process.env.NEXT_PUBLIC_RPC_NAME ?? 'Cabana',
      url: process.env.NEXT_PUBLIC_RPC_ENDPOINT,
      wsUrl:
        process.env.NEXT_PUBLIC_RPC_WEBSOCKET_ENDPOINT ??
        makeWebsocketUrlFromRpcUrl(process.env.NEXT_PUBLIC_RPC_ENDPOINT),
    } as const)
  : null
const ADDITIONAL_RPC_ENDPOINT_POSITION =
  process.env.NEXT_PUBLIC_RPC_ENDPOINT_POSITION === 'last' ? 'last' : 'first'

export const RPC_PROVIDERS = [
  ...(ADDITIONAL_RPC_ENDPOINT_POSITION === 'first' && ADDITIONAL_RPC_ENDPOINT
    ? [ADDITIONAL_RPC_ENDPOINT]
    : []),
  {
    label: 'Triton',
    url: TRITON_URL,
    wsUrl: makeWebsocketUrlFromRpcUrl(TRITON_URL),
  },
  ...(ADDITIONAL_RPC_ENDPOINT_POSITION === 'last' && ADDITIONAL_RPC_ENDPOINT
    ? [ADDITIONAL_RPC_ENDPOINT]
    : []),
] as const

type Cluster = 'mainnet-beta' | 'devnet'
const CLUSTER_ENDPOINTS: Record<
  Cluster,
  { name: Cluster; url: string; wsUrl: string }
> = {
  'mainnet-beta': {
    name: 'mainnet-beta',
    url: RPC_PROVIDERS[0].url,
    wsUrl: RPC_PROVIDERS[0].wsUrl,
  },
  devnet: {
    name: 'devnet',
    url: 'https://realms-develope-935c.devnet.rpcpool.com/67f608dc-a353-4191-9c34-293a5061b536',
    wsUrl:
      'wss://realms-develope-935c.devnet.rpcpool.com/67f608dc-a353-4191-9c34-293a5061b536/whirligig',
  },
} as const
export const CLUSTER_NAME: Cluster = 'mainnet-beta'
export const CLUSTER_ENDPOINT = CLUSTER_ENDPOINTS[CLUSTER_NAME]

export const RPC_PROVIDER_URL_KEY = localStorageKey(
  // bumped 0.4 -> 0.5 to orphan stored Cabana RPC selections (dead host) and
  // reset all returning users to the default provider
  'rpcProviderKey-0.5',
  RPC_PROVIDERS[0].url,
)
export const RPC_PROVIDER_URL_KEY_WITHOUT_DEFAULT = localStorageKey(
  RPC_PROVIDER_URL_KEY.key,
  null,
)

// This is "lossy", in the sense that if a user has a custom rpc url, the ws url will be calculated from the stored url,
// regardless of whether it was previously set from config and was a totally different url.
// This is because setting the ws url is currently only used for dev purposes. To change this, we would need to store
// the ws url in local storage as well and allow users to set it explicitly.
export function makeRpcUrlsFromStorageWithFallback(
  rpcUrlFromStorage: string | null,
): {
  url: string
  wsUrl: string
} {
  return rpcUrlFromStorage &&
    typeof window !== 'undefined' &&
    CLUSTER_ENDPOINT.name === 'mainnet-beta' &&
    URL.canParse(rpcUrlFromStorage)
    ? {
        url: rpcUrlFromStorage,
        wsUrl: makeWebsocketUrlFromRpcUrl(rpcUrlFromStorage),
      }
    : { url: CLUSTER_ENDPOINT.url, wsUrl: CLUSTER_ENDPOINT.wsUrl }
}

// when using Triton RpcPool then use whirligig
// https://docs.triton.one/project-yellowstone/whirligig-websockets
function makeWebsocketUrlFromRpcUrl(rpcUrl: string): string {
  const url = new URL(rpcUrl)
  url.protocol = url.protocol.replace(/^http/, 'ws')
  if (url.hostname.endsWith('rpcpool.com')) {
    url.pathname = url.pathname.replace(/\/?$/, '') + '/whirligig'
  }
  return url.toString()
}

export const PRIORITY_FEE_LEVELS = [
  { label: 'none', value: 0 },
  { label: 'min', value: 1000 },
  { label: 'low', value: 2500 },
  { label: 'med', value: 5000 },
  { label: 'high', value: 7500 },
] as const
export const DEFAULT_PRIORITY_FEE_LEVEL = PRIORITY_FEE_LEVELS[3]
export const PRIORITY_FEE_KEY = localStorageKey<
  (typeof PRIORITY_FEE_LEVELS)[number]['value']
>('priorityFeeKey-0.2', DEFAULT_PRIORITY_FEE_LEVEL.value)

// export const SHOW_STABLE_PRICE_KEY = 'showStablePriceKey-0.1'

// export const SHOW_ORDER_LINES_KEY = 'showOrderLines-0.1'

// export const SHOW_SWAP_INTRO_MODAL = 'showSwapModal-0.1'

// export const ACCEPT_TERMS_KEY = 'termsOfUseAccepted-0.1'

// export const TRADE_LAYOUT_KEY = 'tradeLayoutKey-0.1'

// export const NON_RESTRICTED_JURISDICTION_KEY = 'non-restricted-jurisdiction-0.1'

// export const SHOW_ANNOUNCEMENTS_KEY = 'showAnnouncements-0.1'

export const LAST_WALLET_NAME = localStorageKey('lastWalletName', '')

export const TV_USER_ID_KEY = localStorageKey('tv-userId-0.1', '')

export const AUTO_CONNECT_WALLET = localStorageKey('auto-connect-0.1', true)

export const PRIVACY_MODE = localStorageKey('privacy-mode-0.1', false)
export const PRIVATE_MODE_STRING = '****'
export const SLIPPAGE_KEY = localStorageKey('slippage-0.1', '0.5')

// export const MAX_PRIORITY_FEE_KEYS = 128

// export const SEND_TELEMETRY_KEY = 'sendTelemetry-0.1'

// export const TRADE_FORM_PREFERENCE_KEY = 'tradeFormPreference-0.1'

export const LAMPORT_MODE_KEY = localStorageKey('lamportMode-Key-0.5', 'SOL')

// export const PRO_MODE_KEY = 'proMode-0.1'

export const REFERRER_KEY = localStorageKey<PartnerRef>('referrer-0.2')

export const DEFAULT_TRADE_VALUE_FILTER = {
  SOL: { min: '', max: '' },
  USDC: { min: '', max: '' },
}
export const TRADE_VALUE_FILTER_KEY = localStorageKey(
  'tradeValueFilter-0.2',
  DEFAULT_TRADE_VALUE_FILTER,
)

export const TRADER_ADDRESS_FILTER_KEY = localStorageKey(
  'traderAddressFilter-0.1',
  [] as string[],
)

export const SHOW_SWAP_CHART_KEY = localStorageKey('showSwapChart-0.1', false)
export const SHOW_SWAP_ORDERBOOK_KEY = localStorageKey(
  'showSwapOrderbook-0.1',
  false,
)

export const SEEN_SET_PROFILE_MODAL_KEY = localStorageKey(
  'setProfile-0.1',
  false,
)

// export const PROFILE_CATEGORIES = [
//   'borrower',
//   'day-trader',
//   'degen',
//   'discretionary',
//   'loan-shark',
//   'market-maker',
//   'swing-trader',
//   'trader',
//   'yolo',
// ]

export const QUOTE_ROUTES_ROUTING_MODE =
  process.env.NEXT_PUBLIC_QUOTE_ROUTES_ROUTING_MODE || 'ALL'

// Jupiter swap API - use jupiterFetch from utils/jupiter.ts for authenticated requests
export const JUPITER_V6_QUOTE_API_MAINNET = 'https://api.jup.ag/swap/v2'

export const DFLOW_QUOTE_API = 'https://quote-api.dflow.net'

export const MANGO_DATA_API_URL = 'https://api.mngo.cloud/data/v4'

export const WRAPPED_SOL_MINT = new PublicKey(SOL_MINT)

// Both default to '' so the app runs without Cabana backends.
// Set the NEXT_PUBLIC_* env vars to re-enable.
// Consumers must guard fetches with isTrafficApiEnabled / isUsersApiEnabled.
export const TRAFFIC_API_URL = process.env.NEXT_PUBLIC_TRAFFIC_API_URL || ''

export const USERS_API_URL =
  process.env.NEXT_PUBLIC_USERS_SERVICE_URL ||
  (TRAFFIC_API_URL ? `${TRAFFIC_API_URL}/users` : '')

export const isTrafficApiEnabled = () => TRAFFIC_API_URL !== ''
export const isUsersApiEnabled = () => USERS_API_URL !== ''

export const USER_TOKEN_KEY = localStorageKey(
  'user-token-0.1',
  null as string | null,
)

export const LITE_RPC_URL = TRITON_URL
export const LITE_RPC_BACKUP_URL =
  'https://idalina-qy4oxi-fast-mainnet.helius-rpc.com/'

// export const DEFAULT_MARKET_NAME = 'SOL/USDC'

// export const MIN_SOL_BALANCE = 0.001

// export const ACCOUNT_ACTION_MODAL_HEIGHT = '462px'

// export const ACCOUNT_ACTION_MODAL_INNER_HEIGHT = '400px'

// export const TRADE_VOLUME_ALERT_KEY = 'tradeVolumeAlert-0.1'

// export const PAGINATION_PAGE_LENGTH = 250

// export const PROGRAM_ID = process.env.NEXT_PROGRAM_ID || 'programId'

export const NOTIFICATION_API = 'https://notifications-api.herokuapp.com'

export const NOTIFICATION_API_WEBSOCKET =
  'wss://notifications-api.herokuapp.com/ws'

export const POPULAR_SWAP_TOKENS: TokenMetadataItem[] = [
  SOLANA_TOKEN_DETAILS,
  USDC_TOKEN_DETAILS,
  {
    symbol: 'USDT',
    name: 'USDT',
    mint: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    image_url: '/icons/usdt.svg',
    latest_price_usd: 1,
    volume_24h_usd: 0,
    amount_24h: 0,
    trades_count_24h: 0,
    decimals: 6,
    description: '',
    twitter: '',
    telegram: '',
    coingecko_id: 'tether',
    website: 'https://tether.to/',
    token_program: TOKEN_PROGRAM_ID.toBase58(),
  },
  // {
  //   symbol: 'WIF',
  //   name: 'dogwifhat',
  //   mint: 'EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm',
  //   image_url:
  //     'https://bafkreibk3covs5ltyqxa272uodhculbr6kea6betidfwy3ajsav2vjzyum.ipfs.nftstorage.link',
  // },
  // {
  //   symbol: 'JUP',
  //   name: 'Jupiter',
  //   mint: 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN',
  //   image_url: 'https://static.jup.ag/jup/icon.png',
  // },
  // {
  //   symbol: 'BONK',
  //   name: 'Bonk',
  //   mint: 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263',
  //   image_url:
  //     'https://arweave.net/hQiPZOsRZXGXBJd_82PhVdlM_hACsT_q6wqwf5cSY7I?ext=png',
  // },
  // {
  //   symbol: 'mangoSOL',
  //   name: 'Mango Staked SOL',
  //   mint: 'MangmsBgFqJhW4cLUR9LxfVgMboY1xAoP8UUBiWwwuY',
  //   image_url: 'https://mango.markets/images/tokens/mangoSOL.svg',
  // },
  // {
  //   symbol: 'mSOL',
  //   name: 'Marinade Staked SOL',
  //   mint: 'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So',
  //   image_url:
  //     'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So/logo.png',
  // },
  // {
  //   symbol: 'jitoSOL',
  //   name: 'Jito Staked SOL',
  //   mint: 'J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn',
  //   image_url: 'https://storage.googleapis.com/token-metadata/JitoSOL-256.png',
  // },
  // {
  //   symbol: 'PYTH',
  //   name: 'Pyth Network',
  //   mint: 'HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3',
  //   image_url: 'https://pyth.network/token.svg',
  // },
  // {
  //   symbol: 'RENDER',
  //   name: 'Render',
  //   mint: 'rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof',
  //   image_url:
  //     'https://shdw-drive.genesysgo.net/5zseP54TGrcz9C8HdjZwJJsZ6f3VbP11p1abwKWGykZH/rndr.png',
  // },
  // {
  //   symbol: 'HNT',
  //   name: 'Helium',
  //   mint: 'hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux',
  //   image_url:
  //     'https://shdw-drive.genesysgo.net/CsDkETHRRR1EcueeN346MJoqzymkkr7RFjMqGpZMzAib/hnt.png',
  // },
  // {
  //   symbol: 'RAY',
  //   name: 'Raydium',
  //   mint: '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R',
  //   image_url:
  //     'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R/logo.png',
  // },
  // {
  //   symbol: 'W',
  //   name: 'Wormhole',
  //   mint: '85VBFQZC9TZkfaptBWjvUw7YbZjy52A6mjtPGjstQAmQ',
  //   image_url: 'https://wormhole.com/token.png',
  // },
  // {
  //   symbol: 'JTO',
  //   name: 'Jito',
  //   mint: 'jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL',
  //   image_url: 'https://metadata.jito.network/token/jto/image',
  // },
]

export const makeWalletExplorerUrl = (walletPk: string) =>
  `https://app.step.finance/portfolio?wallet=${encodeURIComponent(walletPk)}`

export const getTradeSizeEmoji = (size: number) => {
  if (size <= 500) {
    return '🦐'
  } else if (size > 500 && size <= 2000) {
    return '🐟'
  } else if (size > 2000 && size <= 10000) {
    return '🦈'
  } else return '🐋'
}

export const DAOS_REFS = [
  {
    name: 'Realms Ecosystem DAO',
    wallet: '6mDmzi8BH3FgJD6VMNQfvtCF2t8HS4GZWhqNwFCFFTMu',
    ref: 'Realms',
    partnerStartAtUnixTime: 1748954584,
  },
  {
    name: 'Island Dao',
    wallet: 'EZ3V9DRoUpewNyNTyG3ya7TiPwe27XGDCgFHgfXNprJX',
    ref: 'IslandDao',
    partnerStartAtUnixTime: 1748954584,
  },
  {
    name: 'Blockride',
    wallet: 'EL6DpQipV7G7wdXvwSm82Y64iCUWh4xUs2YJ3xhyMhDE',
    ref: 'Blockride',
    partnerStartAtUnixTime: 1748954584,
  },
  {
    name: 'Epicentral DAO',
    wallet: 'DR1P6yBNXQ8YLBrpYpU3FjnnruStMRzm2y2cAA3D6ynm',
    ref: 'Epicentral',
    partnerStartAtUnixTime: 1748954584,
  },
  {
    name: 'SafeMoon',
    wallet: '731wmTrh8ADUuS62nCw7XJojiZLWT1Qso9VQdFRzfJJm',
    ref: 'safemoon',
    partnerStartAtUnixTime: 1750099955,
  },
  {
    name: 'None',
    wallet: '',
    partnerStartAtUnixTime: 1748954584,
  },
]

export const LANGS = [
  { locale: 'en', name: 'english', description: 'english' },
  { locale: 'zh', name: 'chinese', description: 'simplified chinese' },
] as const
export const LANGUAGE_KEY = localStorageKey<string>('language', 'en')

export const CABANATORS = [
  'H9jSCQVLUnMv4c99MZQKJ3Be52W4TTHGcGRLkr8kRfko', //victor
  'DJCh1SEmRuzodXP4zbMtEzGXA6zcdrctS2JZ1rbG8sLa', //deji
  'GsZzHbGBcL3kqPbDeqwc1rmdTN1t5G2QkM62jussjR2R', //himar
  'HMiTbvNEbm1PSuH4er4cKHXY53t9Y1fAoUTvjFjumLNc', //baron
  '2wUw8YSdPR8xt2UB5mkNaAvoLRFEbueAHVtfraTMSVw9', //don marvey
  'BbrW5CnNLvxkjPPwhFBqpSL4iVdctKdcCy1yhxeGws6g', //Davey
  'CrezavdVqRKfFWoB2RoBPgsUBUH3qmAYyHTTkQkhTfMQ', //victor
  'Es5A4EBVSEtJs9U9RvbEHRd6S5Fjckw6qjVG86BFJBN7', //Dele
]
